<!--  -->
import { setTimeout } from 'timers';
<template>
    <div class='container box box_between' id="conainer_pymonitor">
        <div class="bg box_f1  box box_v">
            <div class="title">事件上报</div>
            <div class="list_item box box_f1" v-for="(item,index) in eventlist" :key="index" :class="{'active':index==selectIndex}">
                <div class="dot"></div>
                <div class="item_text box_f1"><div class="slh" :style="'width:'+width">{{item.title}}</div></div>
                <div class="item_text" style="width:150px">{{item.dateTime}}</div>
            </div>
        </div>
        <div class="bg box_f1 box box_v">
            <div class="title">不动产业务办理</div>
            <div class="list_item box_f1 box" v-for="(item,index) in estatelist" :key="index" :class="{'active':index==selectIndex}">
                <div class="dot"></div>
                <div class="item_text box_f1"><div class="slh" :style="'width:'+width">{{item.title}}</div></div>
                <div class="item_text" style="width:150px">{{item.dateTime}}</div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            eventlist:[],
            estatelist:[],
            width:'0px',
            timer:null,
            selectIndex:0,
        };
    },
     props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        show:{
            handler(newVal){
                if(newVal){
                    this.eventlist=[]
                    this.estatelist=[]
                    this.selectIndex=0
                    this.getEvent()
                    this.getEstate()
                    this.timer = setInterval(()=>{
                        if(this.selectIndex > 2){
                            this.selectIndex = 0 
                        }else{
                            this.selectIndex++
                        }
                        console.log('首页 setInterval')
                    },5000)
                }else{
                    this.timer && clearInterval(this.timer)
                }
            },
            immediate:true
        }
    },
    //方法集合
    methods: {
        getEvent(){
            this.$get(this.urlobj.eventLatest10).then(res=>{
                this.eventlist = res.rows.slice(0,4)
            })
        },
        getEstate(){
            this.$get(this.urlobj.eatateLatest10).then(res=>{
                this.estatelist = res.rows.slice(0,4)
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.width = document.getElementById("conainer_pymonitor").offsetWidth/2 - 270 +'px'
            
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
        this.timer=null
        console.log('clearInterval')
    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    padding:0 20px;
    width:100%;
    height:100%;
}
.bg{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
    margin-top:10px;
    margin-right:20px;
}
.bg:last-child{
    margin-right:0px;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px;
    margin-bottom:24px;
}
.list_item{
    margin: 0 10px 10px 10px;
    //padding: 10px 0;
    border-top:1px dashed #00A0E9;
    border-bottom: 1px dashed #00a0e9;
    align-items: center;
    color:#09D4FF;
    font-size: 14px;
    .dot{
        background: #8FC31F;
        border-radius: 50%;
        height:8px;
        width:8px;
        margin-right:5px
    }
   
}
.active{
    box-shadow:0 0 20px #008cff inset; 
    border:none;
    color:#34FFB5;
}

</style>